import React from "react";
import LoadingSpinner from "../ui/LoadingSpinner";

const AdditionalReportModal = ({
  show,
  onClose,
  userData,
  translations,
  currencySymbol,
  plans,
  loading,
  onPurchase,
  plansLoading,
  displayLanguage,
}) => {
  if (!show || !userData) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: "500px",
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "32px",
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
          zIndex: 1050,
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "24px",
              lineHeight: "1",
              color: "gray",
              cursor: "pointer",
              padding: 0,
              marginBottom: "1px",
            }}
          >
            &times;
          </button>
        </div>

        <h2
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#111827",
            textAlign: "center",
            margin: 0,
            marginBottom: "0px",
          }}
        >
          {translations.requestAdditionalReport}
        </h2>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              margin: "12px auto 20px",
              display: "inline-block",
              padding: "6px 12px",
              backgroundColor: "#2563eb",
              borderRadius: "9999px",
              color: "#fff",
              fontSize: "13px",
              fontWeight: "500",
            }}
          >
            {userData?.planType || translations.annualSubscriber}
          </div>
        </div>

        <div
          style={{
            padding: "16px 20px",
            border: "1px solid #e5e7eb",
            borderRadius: "10px",
            marginBottom: "20px",
            backgroundColor: "#f9fafb",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                backgroundColor: "#2563eb",
                color: "#fff",
                fontSize: "12px",
                marginRight: "8px",
                flexShrink: 0,
              }}
            >
              ℹ
            </span>
            <strong
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#111827",
              }}
            >
              {translations.yourCurrentSubscription}
            </strong>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "18px",
                  color: "rgb(71 127 248)",
                  fontWeight: "600",
                }}
              >
                {translations.active}
              </div>
              <div style={{ fontSize: "12px", color: "#6b7280" }}>
                {translations.subscriptionStatus}
              </div>
            </div>
            <div>
              <div
                style={{
                  fontSize: "18px",
                  color: "rgb(71 127 248)",
                  fontWeight: "600",
                }}
              >
                {new Date(
                  Date.now() + 30 * 24 * 60 * 60 * 1000
                ).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                })}
              </div>
              <div style={{ fontSize: "12px", color: "#6b7280" }}>
                {translations.nextScheduled}
              </div>
            </div>
          </div>

          <p
            style={{
              fontSize: "13px",
              color: "#374151",
              lineHeight: "1.5",
            }}
          >
            {translations.subscriptionDescription
              .replace(
                "{planType}",
                userData?.planType?.toLowerCase() ||
                  translations.annual.toLowerCase()
              )
              .replace(
                "{reportType}",
                userData?.planType === translations.annualSubscriber
                  ? translations.monthlyReports
                  : translations.regularReports
              )
              .replace(
                "{date}",
                new Date(
                  Date.now() + 30 * 24 * 60 * 60 * 1000
                ).toLocaleDateString(
                  displayLanguage === "ja" ? "ja-JP" : "en-US",
                  {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  }
                )
              )}
          </p>
        </div>

        <div
          style={{
            padding: "16px 20px",
            border: "1px solid #e5e7eb",
            borderRadius: "10px",
            marginBottom: "20px",
            backgroundColor: "#f9fafb",
          }}
        >
          <p
            style={{
              fontSize: "13px",
              color: "#374151",
              lineHeight: "1.6",
            }}
          >
            {translations.additionalReportDescription}
          </p>
        </div>

        <div
          style={{
            padding: "20px",
            border: "2px solid #2563eb",
            borderRadius: "10px",
            marginBottom: "24px",
            backgroundColor: "#f0f8ff",
            textAlign: "center",
          }}
        >
          {/* <div
            style={{
              fontSize: "24px",
              color: "#2563eb",
              fontWeight: "700",
            }}
          >
            {displayLanguage === "ja" ? "¥1000" : "$10"}
          </div> */}
          {plansLoading ? (
            <div>Loading...</div>
          ) : (
            <div
              style={{
                fontSize: "24px",
                color: "#2563eb",
                fontWeight: "700",
              }}
            >
              {currencySymbol}
              {plans[0]?.price || 0}
            </div>
          )}
          <div
            style={{
              fontSize: "14px",
              color: "#2563eb",
              marginBottom: "12px",
            }}
          >
            {translations.oneTimePayment}
          </div>

          <div
            style={{
              fontSize: "13px",
              color: "#374151",
              lineHeight: "1.6",
            }}
          >
            {translations.additionalReportFeatures.map((feature, index) => (
              <div key={index}>• {feature}</div>
            ))}
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "rgb(241 241 241)",
              fontSize: "12px",
              fontWeight: "700",
              color: "black",
              cursor: "pointer",
            }}
          >
            {translations.cancel}
          </button>
          <button
            onClick={onPurchase}
            disabled={loading || plansLoading}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              width: "75%",
              backgroundColor: loading || plansLoading ? "#9ca3af" : "#2563eb",
              color: "#fff",
              fontSize: "12px",
              fontWeight: "500",
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: "0 4px 12px rgba(37, 99, 235, 0.2)",
            }}
          >
            {loading || plansLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  style={{ width: "14px", height: "14px" }}
                />
                {translations.processing}
              </>
            ) : (
              translations.purchaseAdditionalReport
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdditionalReportModal;
